import { useCallback } from 'react';

import { useBusinessUnitContext } from '~/contexts/BusinessUnitContext/BusinessUnitContext';
import { generateSearchUrl } from '~/utils/search/generateSearchUrl';
import type { SearchParams } from '~/utils/search/types';

export const useGenerateSearchUrl = () => {
  const { businessUnit, country } = useBusinessUnitContext();

  return useCallback(
    (params: SearchParams) => generateSearchUrl(params, businessUnit, country),
    [businessUnit, country],
  );
};
